<div class="identifyOrAnonymous">
  <div><img src="../../assets/images/helpingHands.svg" alt="" /></div>
  <p>
    Select the food item you want to give
  </p>

  <form>
    <div class="ui form">
      <div class="field">
        <label>Rice</label>
        <select>
          <option value="">Select amount</option>
          <option value="1">1kg</option>
          <option value="2">2kg</option>
          <option value="3">3kg</option>
          <option value="4">4kg</option>
        </select>
      </div>
      <div class="field">
        <label>Beans</label>
        <select>
          <option value="">Select amount</option>
          <option value="1">1kg</option>
          <option value="2">2kg</option>
          <option value="3">3kg</option>
          <option value="4">4kg</option>
        </select>
      </div>
      <div class="field">
        <label>Others</label>
        <select>
          <option value="">Select food stuff</option>
          <option value="oil">Oil</option>
          <option value="groundnut">groundnut</option>
          <option value="maize">maize</option>
          <option value="yams">Yams</option>
          <option value="eggs">Eggs</option>
        </select>
      </div>
    </div>

    <button type="submit" class="fluid ui primary button">
      Start <i hidden class="fas fa-circle-notch fa-spin"></i>
    </button>
  </form>
</div>
